import { cloneDeep } from 'lodash';
import { groupKostenByPosition } from '../../../../../utils/helper';
import { get } from 'lodash';
import { set } from 'lodash';

import Schema from '../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
const P = Schema.attributes;

export const executeVerwendungsFormulas = (application: any, kostenKategories: any) => {
	let appCopy = cloneDeep(application);
	let result: any[] = [];
	const kostenKategoriesGroup = groupKostenByPosition(kostenKategories);

	if (get(kostenKategoriesGroup, 'Ausgabe', []).length > 0) {
		let caculatedAusgaben = calculateAusgaben(appCopy);
		result.push(...caculatedAusgaben);
		for (let ele of caculatedAusgaben) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}

	if (get(kostenKategoriesGroup, 'Einnahme', []).length > 0) {
		let caculatedEinnahmen = calculateEinnahmen(appCopy);
		result.push(...caculatedEinnahmen);
		for (let ele of caculatedEinnahmen) {
			set(appCopy, get(ele, 'path'), get(ele, 'value'));
		}
	}

	let caculatedGesamtKosten = calculateGesamtKosten(appCopy);
	result.push(...caculatedGesamtKosten);

	return result;
};

function calculateAusgaben(application: any) {
	let result: any = [];
	const allAusgabenArr = get(application, P.Ausgaben.path, []);

	let gesamtAusgabe = 0;
	for (let i = 0; i < allAusgabenArr.length; i++) {
		const eachAusgaben = allAusgabenArr[i];
		let eachAusgabenVerausgabtSumme = 0;
		let eachAusgabenAnerkanntSumme = 0;
		for (let ele of get(eachAusgaben, 'Ausgaben_Ausgaben_Block_1', [])) {
			eachAusgabenVerausgabtSumme += parseFloat(get(ele, 'Zelle_2', '0.0'));
			eachAusgabenAnerkanntSumme += parseFloat(get(ele, 'Zelle_3', '0.0'));
		}
		gesamtAusgabe += eachAusgabenVerausgabtSumme;
		result.push(
			{
				path: `${P.Ausgaben.path}.${i}.Zelle_2`,
				value: !isNaN(Number(eachAusgabenVerausgabtSumme)) ? parseFloat(eachAusgabenVerausgabtSumme.toFixed(2)) : 0.0,
			},
			{
				path: `${P.Ausgaben.path}.${i}.Zelle_3`,
				value: !isNaN(Number(eachAusgabenAnerkanntSumme)) ? parseFloat(eachAusgabenAnerkanntSumme.toFixed(2)) : 0.0,
			},
		);
	}
	result.push({
		path: P.Zusammenfassung_Gesamtausgaben.path,
		value: !isNaN(gesamtAusgabe) ? gesamtAusgabe.toFixed(2) : 0.0,
	});

	return result;
}
function calculateEinnahmen(application: any) {
	let result: any = [];
	const allEinnahmenARR = get(application, P.Einnahmen.path, []);
	let gesamtEinnahme = 0;
	for (let i = 0; i < allEinnahmenARR.length; i++) {
		const eachEinnahmen = allEinnahmenARR[i];
		let eachEinnahmenVerausgabtSumme = 0;
		let eachEinnahmenAnerkanntSumme = 0;
		for (let ele of get(eachEinnahmen, 'Einnahmen_Einnahmen_Block_1', [])) {
			eachEinnahmenVerausgabtSumme += parseFloat(get(ele, 'Zelle_2', '0.0'));
			eachEinnahmenAnerkanntSumme += parseFloat(get(ele, 'Zelle_3', '0.0'));
		}
		gesamtEinnahme += eachEinnahmenVerausgabtSumme;
		result.push(
			{
				path: `${P.Einnahmen.path}.${i}.Zelle_2`,
				value: !isNaN(eachEinnahmenVerausgabtSumme) ? eachEinnahmenVerausgabtSumme.toFixed(2) : 0.0,
			},
			{
				path: `${P.Einnahmen.path}.${i}.Zelle_3`,
				value: !isNaN(eachEinnahmenAnerkanntSumme) ? eachEinnahmenAnerkanntSumme.toFixed(2) : 0.0,
			},
		);
	}
	result.push({
		path: P.Zusammenfassung_Gesamteinnahmen.path,
		value: !isNaN(gesamtEinnahme) ? gesamtEinnahme.toFixed(2) : 0.0,
	});

	return result;
}

function calculateGesamtKosten(application: any) {
	let result: any = [];
	const gesamtAusgabe = get(application, P.Zusammenfassung_Gesamtausgaben.path, 0);
	const gesamtEinnahme = get(application, P.Zusammenfassung_Gesamteinnahmen.path, 0);
	const gesamtKosten = gesamtAusgabe > 0 ? gesamtAusgabe - gesamtEinnahme : 0;

	result.push({
		path: P.Zusammenfassung_Gesamtkosten.path,
		value: !isNaN(gesamtKosten) ? gesamtKosten.toFixed(2) : 0,
	});

	return result;
}
